module.exports = __webpack_public_path__ + "static/media/AppStore.1d786bee.svg";